// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const crustle: PokeData = {
  "id": 558,
  "name": "crustle",
  "height": 14,
  "weight": 2000,
  "base_experience": 170,
  "types": [
    PokeType.BUG,
    PokeType.ROCK
  ],
  "api_moves": [
    "sand-attack",
    "withdraw",
    "rock-slide",
    "slash",
    "flail",
    "feint-attack",
    "fury-cutter",
    "rock-blast",
    "rock-polish",
    "x-scissor",
    "rock-wrecker",
    "stealth-rock",
    "bug-bite",
    "smack-down",
    "shell-smash"
  ],
  "moves": [
    "rock-slide",
    "rock-blast",
    "stealth-rock",
    "bug-bite",
    "seismic-toss",
    "leech-steal",
    "lunge",
    "string-shot",
    "boulder_bash",
    "ancient-power",
    "stone-crush",
    "pounce",
    "bug-buzz"
  ],
  "evolution_chain": {
    "id": 284,
    "item": null,
    "species": [
      {
        "name": "dwebble",
        "order": 558,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "crustle",
        "order": 559,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 557,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 145,
    "speed": 77,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
